import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-event-list',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.less']
})
export class EventListComponent {
  @Input() data: any;
}
